import React from "react"
import SearchIcon from "@mui/icons-material/Search"
import Badge from "@mui/material/Badge"
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined"
import {
  Container,
  Wrapper,
  Left,
  SearchContainer,
  Input,
  Logo,
  Center,
  Right,
  MenuItem,
  StyledLink,
  ExternalLink,
} from "../styles/NavbarStyle"
import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { logout } from "../redux/apiCall"

const Navbar = () => {
  const quantity = useSelector((state) => state.cart.quantity)
  const user = useSelector((state) => state.user.currentUser)
  const dispatch = useDispatch()

  const onLogout = () => {
    logout(dispatch)
  }

  return (
    <Container>
      <Wrapper>
        <Left>
          <SearchContainer>
            <Input placeholder='Search' disabled />
            <SearchIcon style={{ color: "gray", fontSize: 16 }}></SearchIcon>
          </SearchContainer>
        </Left>
        <Center>
          <StyledLink to='/'>
            <Logo>Store</Logo>
          </StyledLink>
        </Center>
        <Right>
          {user ? (
            <MenuItem onClick={onLogout}>Logout</MenuItem>
          ) : (
            <>
              <ExternalLink
                href='https://store-admin.kamelberkani.com'
                target='_blank'
                rel='noreferrer'>
                <h3>Dashboard</h3>
              </ExternalLink>
              <StyledLink to='/register'>
                <MenuItem>Register</MenuItem>
              </StyledLink>
              <StyledLink to='/login'>
                <MenuItem>Login</MenuItem>
              </StyledLink>
            </>
          )}

          <Link to='/cart'>
            <MenuItem>
              <Badge badgeContent={quantity} color='primary'>
                <LocalMallOutlinedIcon color='action' />
              </Badge>
            </MenuItem>
          </Link>
        </Right>
      </Wrapper>
    </Container>
  )
}

export default Navbar
